import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__debug_feature_shared } from '@shared/enums/ENUM__debug_feature_shared';
import { FN_DTO_BASE__try_assert_standard_fields_array } from './FN_DTO_BASE__try_assert_standard_fields_array';

export function FN_DTO_BASE__try_assert_standard_fields(possible_dto: any) {
  if (!(possible_dto instanceof DTO__base)) return;
  if (possible_dto.is_stub()) return;

  if (ENUM__debug_feature_shared.ASSERT_STANDARD_FIELDS) {
    possible_dto.assert_standard_fields();
  }

  for (let value of Object.values(possible_dto)) {
    FN_DTO_BASE__try_assert_standard_fields_array(value);
    FN_DTO_BASE__try_assert_standard_fields(value);
  }

  possible_dto.on_assert_standard_fields_passed();
}
